import { FC } from "react";
import { Tr, Td, Box } from "@chakra-ui/react";
import { Row } from "react-table";
import {
  cellStyles,
  fixedColumnShadow,
  fixedColumnStyle,
} from "../../../utils/styles/tableStyles";
import { FixedColumn } from "./FixedColumn";
import { getFixedColumnProps } from "./helpers/getFixedColumnProps";
import { primaryColor } from "../../../utils/colors";

interface TableRowProps {
  row: Row;
  fixedColumnIds?: FixedColumn[];
  rowIndex: number;
  columnsStyle?: string[];
  hasScroll: boolean;
  fixedColumnWidths: number[];
  editingRowIndex?: string | number | null;
  isHighlighted: boolean;
}

const TableRow: FC<TableRowProps> = ({
  row,
  fixedColumnIds,
  rowIndex,
  columnsStyle,
  hasScroll,
  fixedColumnWidths,
  editingRowIndex,
  isHighlighted = false,
}) => {
  const isEditing = editingRowIndex === rowIndex;

  return (
    <Tr
      {...row.getRowProps()}
      key={row.id}
      sx={{
        border: isEditing ? "1px solid" : "none",
        borderColor: isEditing ? primaryColor : "inherit",
        backgroundColor: isHighlighted ? "gray.300 !important" : "inherit",
      }}
    >
      {row.cells.map((cell) => {
        const isStyledColumn = columnsStyle?.includes(cell.column.id);
        const backgroundColor = isStyledColumn
          ? rowIndex % 2 === 0
            ? "gray.200"
            : "gray.100"
          : "inherit";

        const { fixedColumn, rightOffset } = getFixedColumnProps(
          cell.column.id,
          fixedColumnIds,
          fixedColumnWidths,
        );

        return (
          <Td
            {...cell.getCellProps()}
            sx={{
              backgroundColor: `${backgroundColor} !important`,
              ...cellStyles,
              ...(fixedColumn &&
                hasScroll && {
                  ...fixedColumnStyle,
                  right: `${rightOffset}px`,
                }),
            }}
            key={`${row.id}-${cell.column.id}`}
            border="none"
          >
            <Box
              py="4"
              px="6"
              sx={{
                ...(fixedColumn &&
                  fixedColumn.hasShadow &&
                  hasScroll && {
                    ...fixedColumnShadow,
                  }),
              }}
            >
              {cell.render("Cell")}
            </Box>
          </Td>
        );
      })}
    </Tr>
  );
};

export default TableRow;
